export {
  addItemToSearchHistory,
  clearSearchHistory,
  getSearchHistory,
  mapFormToSearchItem,
  SearchHistory,
} from './SearchHistory';
export type { SearchHistoryItem, SearchHistoryType } from './SearchHistory';
